import { Stack } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { Route } from '../../../routes/account.3ds_.$id_.tsx';
import { useThreeDSQuery, useThreeDSResolveMutation } from '../../../api/3ds.ts';
import { ThreeDSError, ThreeDSLoading } from '../ThreeDSPage/ThreeDSState.tsx';
import { ThreeDSStatus } from '../ThreeDSPage/ThreeDSStatus.tsx';
import { ThreeDSDetails } from '../ThreeDSPage/ThreeDSDetails.tsx';
import { ThreeDSActions } from '../ThreeDSPage/ThreeDSActions.tsx';

export function ThreeDSPage() {
  const { t } = useTranslation();
  const { id } = Route.useParams();

  const query = useThreeDSQuery({ id });
  const mutation = useThreeDSResolveMutation({ id });

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Confirm card payment')}
          parent={{
            to: '/account/home',
            title: t('Home'),
          }}
        />
      }
      compact
    >
      {query.isPending ? (
        <ThreeDSLoading />
      ) : query.isError ? (
        <ThreeDSError error={query.error} />
      ) : query.isSuccess ? (
        <Stack spacing={4} width="100%" alignItems="center">
          <ThreeDSStatus threeDS={query.data} />
          <ThreeDSDetails threeDS={query.data} />
          <ThreeDSActions threeDS={query.data} mutation={mutation} />
        </Stack>
      ) : null}
    </MainLayout>
  );
}
